// extracted by mini-css-extract-plugin
module.exports = {"preview":"preview_preview__wtXMh","top":"preview_top__1TuRu"};